import { c as _c } from "react/compiler-runtime";
import { Container, clx } from "@medusajs/ui";
import Image from "next/image";
import React from "react";
import PlaceholderImage from "@modules/common/icons/placeholder-image";
type ThumbnailProps = {
  thumbnail?: string | null;
  // TODO: Fix image typings
  images?: any[] | null;
  size?: "small" | "medium" | "large" | "full" | "square";
  isFeatured?: boolean;
  className?: string;
  "data-testid"?: string;
};
const Thumbnail: React.FC<ThumbnailProps> = t0 => {
  const $ = _c(16);
  const {
    thumbnail,
    images,
    size: t1,
    isFeatured,
    className,
    "data-testid": dataTestid
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  const initialImage = thumbnail || images?.[0]?.url;
  const t2 = !isFeatured && size !== "square";
  const t3 = size === "square";
  const t4 = size === "small";
  const t5 = size === "medium";
  const t6 = size === "large";
  const t7 = size === "full";
  let t8;
  if ($[0] !== className || $[1] !== isFeatured || $[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t6 || $[7] !== t7) {
    t8 = clx("relative w-full overflow-hidden p-4 bg-ui-bg-subtle shadow-elevation-card-rest rounded-large group-hover:shadow-elevation-card-hover transition-shadow ease-in-out duration-150", className, {
      "aspect-[11/14]": isFeatured,
      "aspect-[9/16]": t2,
      "aspect-[1/1]": t3,
      "w-[180px]": t4,
      "w-[290px]": t5,
      "w-[440px]": t6,
      "w-full": t7
    });
    $[0] = className;
    $[1] = isFeatured;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== initialImage || $[10] !== size) {
    t9 = <ImageOrPlaceholder image={initialImage} size={size} />;
    $[9] = initialImage;
    $[10] = size;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== dataTestid || $[13] !== t8 || $[14] !== t9) {
    t10 = <Container className={t8} data-testid={dataTestid}>{t9}</Container>;
    $[12] = dataTestid;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
const ImageOrPlaceholder = t0 => {
  const $ = _c(3);
  const {
    image,
    size
  } = t0;
  let t1;
  if ($[0] !== image || $[1] !== size) {
    t1 = image ? <Image src={image} alt="Thumbnail" className="absolute inset-0 object-cover object-center" draggable={false} quality={50} sizes="(max-width: 576px) 280px, (max-width: 768px) 360px, (max-width: 992px) 480px, 800px" fill={true} /> : <div className="w-full h-full absolute inset-0 flex items-center justify-center"><PlaceholderImage size={size === "small" ? 16 : 24} /></div>;
    $[0] = image;
    $[1] = size;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Thumbnail;